import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import {
	CreatePaymentGatewayRequest,
	CreatePaymentGatewayResponse,
} from '../../../type'
import { createPaymentGateway } from '../../services'

interface UseMutationCreatePaymentGatewayProps {
	payload: CreatePaymentGatewayRequest
}

export default function useMutationCreatePaymentGateway(
	props?: UseBaseMutationOptions<
		CreatePaymentGatewayResponse,
		UseMutationCreatePaymentGatewayProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.CreatePaymentGateway],
		mutationFn: (params) => createPaymentGateway(params.payload),
		...props,
	})
}
